import { render, staticRenderFns } from "./CardLicense.vue?vue&type=template&id=71999fe1&"
import script from "./CardLicense.vue?vue&type=script&lang=js&"
export * from "./CardLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports